import SignupOnboarding from './screens/SignupOnboarding';
import Dashboard from './screens/Dashboard';
import DashboardPensacolaAI from './screens/DashboardPensacolaAI';
import MakeQRPayment from './screens/MakeQRPayment';
import PensacolaAI from './screens/PensacolaAI';

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <SignupOnboarding />
      <div className="mt-16">
        <PensacolaAI />
      </div>
      <div className="mt-16">
        <Dashboard />
      </div>
      <div className="mt-16">
        <DashboardPensacolaAI />
      </div>
      {/* <div className="mt-16">
        <MakeQRPayment />
      </div> */}
    </div>
  );
}

export default App;
